import { Outlet } from 'react-router';

import { useUser } from '@/state';
import Loading from '@/components/loading/component';
import { PhotoVogueNav } from '@/components/photovogue/nav/component';

/**
 * Layout shell for the PhotoVogue admin/editorial module.
 *
 * Mirrors the thin auth-gate of `DashboardLayout` — the module sits under the same
 * app-level Okta `<Security>`/`<UserProvider>`, so any authenticated user reaches
 * it (per the "authenticated Okta user = admin" decision; no role gating). It does
 * NOT reuse `DefaultLayout`, which is coupled to open-call stages.
 */
export const PhotoVogueLayout = () => {
  const { user, loading, error } = useUser();

  if (!user && !loading) {
    return <div className="p-6">{error?.message ?? 'Not authorized'}</div>;
  }
  if (loading) {
    return <Loading />;
  }

  return (
    <div className="min-h-screen bg-zinc-50/50">
      <PhotoVogueNav />
      <main className="px-2 py-4 md:px-6">
        <Outlet />
      </main>
    </div>
  );
};

export default PhotoVogueLayout;
